import { createContext } from "react";

const AppearanceContext = createContext();
AppearanceContext.displayName = "AppearanceContext";

export default AppearanceContext;
